import request from '@/utils/request'

export function getNoteList(data) {
  return request({ url: '/note/list', method: 'post', data })
}

export function getNoteDetail(id) {
  return request({ url: '/note/detail', method: 'post', data: { id } })
}

export function addNote(data) {
  return request({ url: '/note/add', method: 'post', data })
}

export function updateNote(data) {
  return request({ url: '/note/update', method: 'post', data })
}

export function deleteNote(id) {
  return request({ url: '/note/delete', method: 'post', data: { id } })
}

export function getNoteCategoryList() {
  return request({ url: '/noteCategory/list', method: 'post' })
}

export function addNoteCategory(data) {
  return request({ url: '/noteCategory/add', method: 'post', data })
}

export function updateNoteCategory(data) {
  return request({ url: '/noteCategory/update', method: 'post', data })
}

export function deleteNoteCategory(id) {
  return request({ url: '/noteCategory/delete', method: 'post', data: { id } })
}
